<template>

    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->

            <h1>{{$t('voter_list')}}</h1>
            <h2 class="mb-4">{{$t('contact_information')}}</h2>
            <div class="form-row">
                <div class="col-md-6 mb-3">
                    <label for="email">{{$t('email')}}</label>
                    <input id="email" type="email" class="form-control" v-model="email" autocomplete="off" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$" required>
                    <div class="invalid-feedback">{{$t('valid_email')}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-6 mb-4">
                    <label for="confirmEmail">{{$t('confirm_email')}}</label>
                    <input id="confirmEmail" type="email" class="form-control" v-model="confirm_email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$" required>
                    <div class="invalid-feedback">{{$t('valid_confirm_email')}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-7 mb-3">
                    <label for="phoneNumber">{{$t('phone_number')}}</label>
                    <input id="phoneNumber" type="tel" class="form-control" pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}" v-model="phone" @input="formatPhone" required>
                    <small class="form-text text-muted">
                        000-000-0000
                    </small>
                    <div class="invalid-feedback">{{$t('valid_phone')}}</div>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col"><button class="btn btn-outline-secondary mt-4 float-right" @click="prev_step">{{$t('previous')}}</button></div>
                <div class="col-auto"><button class="btn btn-secondary mt-4 ml-3" @click="next_step">{{$t('next')}}</button></div>
            </div>
            <!-- ***** end custom content ***** -->
        </form>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                email: "",
                confirm_email: "",
                phone: "",
                voter: {},
                valid_email: true,
                valid_phone: true,
                valid_confirm: true,
            }
        },
        created: function () {
            this.voter = this.$store.getters.CONTACT_INFO;
            if (this.voter.length > 0) {
                let info = this.voter[0];

                this.email = info.email;
                this.confirm_email = info.email;
                this.phone = info.phone;
            }
        },

        computed: {
            validate_email: function () {
                return ((this.email === null) || this.email === "");
            },
            validate_phone: function () {
                return ((this.phone === null) || this.phone === "");
            },
            validate_confirm_email: function () {
                return (this.email === this.confirm_email);
            },
            valid_form: function () {
                //return (this.email && this.email.length > 0 && this.phone && this.phone.length > 0 && this.email === this.confirm_email);
                let result = (!this.validate_email && !this.validate_phone && this.validate_confirm_email);

                return !result;
            }
        },

        methods: {
            formatPhone() {
                var x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            next_step: function () {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();
                 
                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');
                });

                if (validation === true) {
                    let voter = {
                        phone: this.phone,
                        email: this.email
                    }

                    //this.$store.commit('update_voter', this.voter);
                    //this.$store.dispatch("SAVE_VOTER", this.voter);
                    this.$store.dispatch("SAVE_CONTACT_INFO", voter);
                    //bus.$emit('change-tab', tran('register_vote_four'));
                    this.$router.push({ name: "Step4", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
                }
            },
            prev_step: function () {
                this.$router.push({ name: "Step2", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
            }
        }

    }
</script>